import { render, staticRenderFns } from "./Youth.vue?vue&type=template&id=ddd39428&"
import script from "./Youth.vue?vue&type=script&lang=js&"
export * from "./Youth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports